import logoutMenu from "./logout";
import { currentUserRole } from "../store/constant";

// ==============================|| MENU ITEMS ||============================== //

const refreshHubspotButton = {
  id: "refreshHubspotButton",
  title: "Refresh HubSpot Data",
  type: "button",
};

let items = [];
if (currentUserRole === "Admin") {
  items = [refreshHubspotButton, logoutMenu];
} else {
  items = [refreshHubspotButton, logoutMenu];
}

const menuItems = {
  items: items,
};

export default menuItems;
